import { useQuery } from 'react-query'
import { getCargoFluxShipmentsByJobnumberId } from '../../api/cargoflux_shipments'

export function useCargoFluxShipmentsQuery(jobnumberId) {
  return useQuery(['cargoflux_shipments', jobnumberId], () => getCargoFluxShipmentsByJobnumberId(jobnumberId))
}
